import { computed } from 'vue';
import type { MappedLocation } from '../../../shared/types';

import { useSearchForm } from './search-form-model';
import { searchFormLib } from '../lib';
import { searchFormConfig } from '../config';
import type { SearchFormInitialState, RouteState } from '../types';

export function useMultiCitySearchForm(
  initialState: SearchFormInitialState = {},
) {
  const searchForm = useSearchForm(initialState);
  const canAddRoute = computed(
    () => searchForm.routes.value.length < searchFormConfig.MAX_ROUTE_AMOUNT,
  );

  function addRoute() {
    if (canAddRoute.value) {
      const [lastRoute] = searchForm.routes.value.slice(-1);

      const newRoute = searchFormLib.createRoute({ dep: lastRoute.arr });
      searchForm.routes.value = [...searchForm.routes.value, newRoute];
    }
  }

  function removeRoute(routeId: string) {
    if (searchForm.routes.value.length > 1) {
      searchForm.routes.value = searchForm.routes.value.filter(
        route => route.id !== routeId,
      );
    }
  }

  function updateRouteDeparture(route: RouteState, dep: MappedLocation) {
    const prevRoute = searchFormLib.getPrevRoute(
      route,
      searchForm.routes.value,
    );

    if (prevRoute && !prevRoute.arr) {
      searchForm.updateRoute({ ...prevRoute, arr: dep });
    }

    searchForm.updateRoute({ ...route, dep });
  }

  function updateRouteArrival(route: RouteState, arr: MappedLocation) {
    const nextRoute = searchFormLib.getNextRoute(
      route,
      searchForm.routes.value,
    );

    if (nextRoute && !nextRoute.dep) {
      searchForm.updateRoute({ ...nextRoute, dep: arr });
    }

    searchForm.updateRoute({ ...route, arr });
  }

  return {
    ...searchForm,
    canAddRoute,
    addRoute,
    removeRoute,
    updateRouteDeparture,
    updateRouteArrival,
  };
}
